import React from "react";
import "./RaikoGridStylesheet.scss"

const RaikoGridTwoColumn = (
    {
        children,
        className
    }) => {

    return (
        <div className={`gridTwoColumnContainer ${className}`}>
            {children}
        </div>
    )
}

export default RaikoGridTwoColumn